import { render, staticRenderFns } from "./tongBuKeTang.vue?vue&type=template&id=162485b0&scoped=true&"
import script from "./tongBuKeTang.vue?vue&type=script&lang=js&"
export * from "./tongBuKeTang.vue?vue&type=script&lang=js&"
import style0 from "./tongBuKeTang.vue?vue&type=style&index=0&id=162485b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162485b0",
  null
  
)

export default component.exports